import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { BaseCommand } from '../Command';
import { AccountCreateWizardComponent } from '../../components/account-create-wizard/account-create-wizard.component';
import {
  CreateWizardCommand,
  CreateWizardCommandResponse,
} from './create-wizard-command';

@Injectable()
export class CreateWizardCommandService extends BaseCommand<
  CreateWizardCommand,
  CreateWizardCommandResponse
> {
  constructor(private modalService: NgbModal) {
    super();
  }

  public execute(
    params: CreateWizardCommand,
  ): Observable<CreateWizardCommandResponse> {
    const accountCreateProgressRef = this.modalService.open(
      AccountCreateWizardComponent,
      { size: 'lg', backdrop: 'static', keyboard: false },
    );
    accountCreateProgressRef.componentInstance.params = params;
    return accountCreateProgressRef.componentInstance.accountCreateConfirmation;
  }
}
